import * as React from 'react';

import { HeadingType } from '../../enums';

import { H1, H2, H3, H4 } from './heading.styled';
import { HeadingProps } from './heading.types';

export const Heading: React.FC<HeadingProps> = (props: HeadingProps) => {
  const { type, text, className, as }: HeadingProps = props;
  
  switch (type) {
    case HeadingType.H1:
      return <H1 className={className} as={as}>{text}</H1>;
    case HeadingType.H2:
      return <H2 className={className} as={as}>{text}</H2>;
    case HeadingType.H3:
      return <H3 className={className} as={as}>{text}</H3>;
    case HeadingType.H4:
      return <H4 className={className} as={as}>{text}</H4>;
  }
};
